import { ChakraProvider, SystemContext } from "@chakra-ui/react"
import { ColorModeProvider, type ColorModeProviderProps } from "@hydrologiq/shared/chakra/ColorMode"
import "@fontsource/montserrat"


interface ProviderProps extends ColorModeProviderProps {
  system: SystemContext
  children?: React.ReactNode
  defaultTheme?: "light" | "dark"
}

export function Provider(props: ProviderProps) {
  return (
    <ChakraProvider value={props.system}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  )
}
